<template>

        <div class="wrap inputAreaWrap">
            <div class="wrappedContent inputArea">

                <div class="narrowHeader row">
                    <div class="col-7">
                        <h2>お子さまについて</h2>
                    </div>

                    <div class="col-5 text-right">
                        <img src="@/assets/img/input/indicator_3.png" class="indicatorImg" alt="">
                    </div>
                </div>


                <div class="row mb-3">
                    <div class="col-12 col-md-4 col-lg-5 text-md-right text-center">
                        <label>同一生計の<span class="text-nowrap">お子さま</span><br>（将来のご予定）</label>
                    </div>
                    <div class="col-8 col-lg-7 offset-4 offset-md-0 offset-lg-0 d-flex align-items-center">
                        <select v-model="okosama.ninzuu">
                            <option :value="value" v-for="(value,index) in selectOptionsData(0, 9)" :key="index">{{value}}</option>
                        </select>
                        <span class="unit-label">人</span>
                    </div>
                </div>


                <div class="row mb-3" v-for="(item, index)  in okosama.ages" :key="index">
                    <div class="col-4 col-lg-5 text-right">
                        <label>第{{index + 1}}子の年齢</label>
                    </div>
                    <div class="col-8 col-lg-7 text-nowrap">
                        <select v-model="item.age">
                            <option :value="value" v-for="(value,index) in selectOptionsData(0, 50)" :key="index">{{value}}</option>
                        </select>
                        <div class="btnBox d-inline-block unit-label">
                            <div class="btn" :class="{ active: item.born == 1 }" @click="item.born = 1">歳</div>
                            <div class="btn shusan-yotei" :class="{ active: item.born == 2 }" @click="item.born = 2">年後に出産予定</div><br>
                        </div>
                    </div>

                    <div class="col-4 col-lg-5 text-right">
                        <label>進学希望</label>
                    </div>
                    <div class="col-8 col-lg-7 ">
                        <div class="btnBox small d-inline-block unit-label ml-0 mt-1">
                            <div class="btn" :class="{ active: item.school == 1 }" @click="item.school = 1">高校まで</div>
                            <div class="btn" :class="{ active: item.school == 2 }" @click="item.school = 2">大学まで</div>
                        </div>
                    </div>
                </div>


                <div class="row mt-5">
                    <div class="col-sm-12 col-md-8 offset-md-2 detail-notice">
                        今回のシミュレーションでは、高校までは公立、大学は私立文系にて算出しています。<br>
                        詳細なライフシミュレーションでは、国公立・私立、文系・理系なども細かく設定できます。
                        また、ご家庭の状況に合わせて、趣味や習い事、レジャー費などを考慮したライフスタイルに近い試算が可能です。<br>
                    </div>
                </div>


                <div class="row btn-next-row mt-5">
                    <div class="col text-center">
                        <router-link to="/input4" class="btn btn-outline-primary btn-next">次に進む</router-link>
                    </div>
                </div>

                <div class="row btn-prev-row">
                    <div class="col text-center">
                        <router-link to="/input2" class="btn btn-outline-primary btn-prev">戻る</router-link>
                    </div>
                </div>

            </div>
        </div>

</template>

<script>
export default {
    name: "input3.vue",
    data() {
        return {
            okosama:{
                ninzuu:null,
                ages:[
                    // {
                    //     age:null,
                    //     born:null,
                    // },
                    // {
                    //     age:null,
                    //     born:null,
                    // }
                ],
            },
        }
    },
    methods: {
        setInputsData() {
            this.$store.commit('setOkosama', this.okosama);
        },
        selectOptionsData(start, end, interval=1) {
            let options = [''];
            // console.log(interval);

            for (let i = start; i <= end; i = i+interval) {
                options.push(i);
            }

            return options;
        }
    },
    watch:{
        'okosama.ninzuu' : function (newNinzuu) {
            if(this.okosama.ages.length > newNinzuu) {
                this.okosama.ages.splice(newNinzuu - this.okosama.ages.length, this.okosama.ages.length - newNinzuu);
            }else{
                let loopCount = newNinzuu-this.okosama.ages.length;
                for (let i=0; i<loopCount; i++){
                    this.okosama.ages.push({
                        age:null,
                        born:1,
                        school: null,
                    });
                }
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.okosama = Object.assign({}, vm.okosama, vm.$store.state.okosama);
        });
    },
    beforeRouteLeave(to, from, next) {
        this.setInputsData();
        next();
    }
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
    .shusan-yotei {
        padding: 6px 3px;
    }
}
</style>